/**
 * Created by soundview on 5/26/15.
 */
var Model = require('models/base/model');
module.exports = Model.extend({});